import React from "react";
import { Users, Workflow, FileCheck2, ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { IMAGES } from "../data/mock";

const Services = ({ onInquiry }) => {
  const { t } = useLanguage();

  const services = [
    { icon: Users, title: t.services.service1Title, desc: t.services.service1Desc },
    { icon: Workflow, title: t.services.service2Title, desc: t.services.service2Desc },
    { icon: FileCheck2, title: t.services.service3Title, desc: t.services.service3Desc },
  ];

  return (
    <div className="reveal">
      <div className="grid gap-10 lg:grid-cols-3 lg:items-start">
        <div className="lg:col-span-1">
          <p className="text-xs font-semibold tracking-[0.3em] text-white/50">{t.services.eyebrow}</p>
          <h3 className="mt-3 font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight text-white">
            {t.services.forCompanies}
          </h3>
          <div className="mt-6 overflow-hidden rounded-2xl">
            <img src={IMAGES.companies} alt="Business partnership" className="grayscale-img h-64 w-full object-cover" />
          </div>
        </div>

        <div className="lg:col-span-2 grid gap-5 sm:grid-cols-2">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                className={`glass-card group flex flex-col rounded-2xl p-7 ${i === 2 ? "sm:col-span-2" : ""}`}
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-black">
                  <Icon className="h-6 w-6" />
                </div>
                <h4 className="mt-5 font-display text-xl font-semibold uppercase tracking-wide text-white">
                  {s.title}
                </h4>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-white/60">{s.desc}</p>
                <button
                  onClick={onInquiry}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-white/80 hover:text-white transition-colors"
                >
                  {t.services.learnMore}
                  <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Services;
